import {Injectable} from '@angular/core';
import {IExternalAction} from "../interfaces/external-action.interface";
import {Observable} from "rxjs";
import {HttpInterceptorService} from "@ispm/core/services/http-interceptor.service";

@Injectable()
export class ExternalFileDownloadService implements IExternalAction {
  handleAction(payload?: any): Promise<any> {
    return this.download(payload).toPromise();
  }

  constructor(private _http: HttpInterceptorService) {
  }

  private download(payload: any): Observable<any> {
    //console.log("downloading: "+JSON.stringify(payload));
    return this._http.get('/file/externaldownload/' + payload, null, true,{'X-Disable-Redirect': 'true'})
      .map(response => response.body)
      .map(response => {
        window.location.href = response.url;
        return "Redirect"
      })
      .catch(err => {
        //console.error("Unable to download file: "+err);
        throw new Error("Unable to download file");
      });

  }

}
